import React, { Component } from 'react';
import { Button } from 'reactstrap';
import { withApollo } from 'react-apollo';
import { REFRESH_PAIRING_CODE } from '../../../mutation/mutation';

class RefreshPairingCode extends Component {
  constructor(props) {
    super(props);

    this.refreshPairingCode = this.refreshPairingCode.bind(this);
  }

  refreshPairingCode() {
    const { client, boxId, isLovepix } = this.props;
    const confirm = window.confirm(`⚠️ Are you sure to generate a new pairing code ? ${isLovepix ? 'LOVEBOX V2' : 'LOVEBOX V1'}: it will be effective ${isLovepix ? 'after box reboot (every ~24h or after unpluging/pluging)' : 'in 30sec if the box is plugged, after pluging it otherwise'}`);
    if (!confirm) {
      return;
    }

    client.mutate({
      mutation: REFRESH_PAIRING_CODE,
      variables: {
        boxId: boxId,
      },
    }).catch((err) => {
      console.log('catch', err);
    });
  }

  render() {
    return (
      <Button
        type="submit"
        color="danger"
        onClick={this.refreshPairingCode}>
      Generate a new pairing code
      </Button>
    );
  }
}

export default withApollo(RefreshPairingCode);



// WEBPACK FOOTER //
// ./src/components/sav-lovebox/infos/refresh-pairing-code.js